import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

let firebaseConfig

if (process.env.NODE_ENV === 'development') {
  firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_STAGING_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_STAGING_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_STAGING_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_STAGING_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STAGING_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_STAGING_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_STAGING_APP_ID
  }
}

if (process.env.NODE_ENV === 'production') {
  firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
  }
}

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

export const auth = firebase.auth()
export const db = firebase.firestore()
export default firebase
